import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth.service';
import { Observable } from 'rxjs';
import { CursoService } from '../../services/curso.service';
import { map } from 'rxjs/operators';



@Component({
  templateUrl: 'dashboard.component.html'
})
export class DashboardComponent implements OnInit {



  items: Observable<any[]>;
  
  
  constructor(public authService: AuthService, private service:CursoService) {
    this.items = this.service.list().snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data();
        const id = a.payload.doc.id;
        return { id, ...data as any };
      })));
      
  }

  ngOnInit() {

    
  }



}
